import { Component, OnInit, Input } from "@angular/core";
import { ByProductType, FirebaseService } from "src/app/core";

@Component({
  selector: "ll-summary-by-product",
  templateUrl: "./summary-by-product.component.html",
  styleUrls: ["./summary-by-product.component.scss"]
})
export class SummaryByProductComponent implements OnInit {
  columnNames: string[] = [
    "Product",
    "Units",
    "Avg Price",
    "Sub Total",
    "Service Fees",
    "Tips",
    "Tip %",
    "Total",
    "# Redeemed",
    "% Redeemed",
    "% Revenue"
  ];
  @Input() data: ByProductType[];
  @Input() venue: boolean;
  constructor(private fb: FirebaseService) {}
  ngOnInit() {
    this.data.sort((a, b) => b.total - a.total);
  }

  get tUnits(): number {
    return this.data.reduce((acc, next) => acc + next.units, 0);
  }
  get tAvgPrice(): number {
    return (
      this.data.reduce((acc, next) => acc + next.avg_price * next.units, 0) /
      this.tUnits
    );
  }

  get tSubtotal() {
    return this.data.reduce((acc, next) => acc + next.subtotal, 0);
  }

  get tServiceFees() {
    return this.data.reduce((acc, next) => acc + next.service_fees, 0);
  }
  get tTips() {
    return this.data.reduce((acc, next) => acc + next.tips, 0);
  }
  get tTipPercentage() {
    return this.data.reduce((acc, next) => acc + next.tip_percentage, 0);
  }
  get tTotal() {
    return this.data.reduce((acc, next) => acc + next.total, 0);
  }
  get tRedeemed() {
    return this.data.reduce((acc, next) => acc + next.redeemed, 0);
  }
  get tRedeemedPercentage() {
    // if (this.venue) return this.tRedeemed / this.fb.venue.orders.orders.length;
    return this.tRedeemed / this.fb.analytics.filter.filtered.length;
  }
  get tRevenue() {
    return (
      this.data.reduce((acc, next) => acc + next.revenue_percentage, 0) /
      this.data.length
    );
  }
}
